import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse } from "@/types";

export function useGetCallSignedAudioUrl({
  callId,
  enabled = true,
}: {
  callId: string;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: ["calls/signed-audio-url", callId],
    enabled,
    queryFn: async () => {
      const path = `calls/${callId}/signed-audio-url`;
      const res = await guacHttpClient.get<string, HttpResponse<string>>(path);
      return res.data;
    },
  });
}
